import { authedJSON } from './http'

export interface SettingsResponse {
  values: Record<string, string>
}

export async function fetchSettings(): Promise<Record<string, string>> {
  const res = await authedJSON<SettingsResponse>('/api/settings')
  return res.values ?? {}
}

export async function putSetting(key: string, value: string): Promise<void> {
  await authedJSON(`/api/settings/${encodeURIComponent(key)}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  })
}

export async function deleteSetting(key: string): Promise<void> {
  await authedJSON(`/api/settings/${encodeURIComponent(key)}`, {
    method: 'DELETE',
  })
}

export async function bulkUpsertSettings(items: Record<string, string>): Promise<void> {
  await authedJSON('/api/settings/bulk', {
    method: 'POST',
    body: JSON.stringify({ items }),
  })
}
